export default __webpack_public_path__ + "static/media/Magadhi_cm_2.7aa0bce9.mp3";